import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { ModalBody } from "reactstrap";
import { useDispatch } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";
import axiosInstance from "../../../../redux/api";
import { isDuplicateSkill } from "../../../../utils/skillUtils";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";

export default function ProfileModelSkills({
  edittype,
  formData,
  setFormData,
  setModalSkills,
}) {
  const [validation, setValidation] = useState(false);
  const [popularSkills, setPopularSkills] = useState([]);
  const [allSkills, setAllSkills] = useState([]);
  const [selectSkills, setSelectSkills] = useState(null);
  const [selectedSkills, setSelectedSkills] = useState(formData.skills || []);
  const [manualSkill, setManualSkill] = useState("");
  const [addmanual, setAddmanual] = useState(false);

  const dispatch = useDispatch();

  // ✅ Utility: get all category + subcategory IDs
  const getCategoryIds = (categories) => {
    if (!Array.isArray(categories)) return "";
    const ids = categories.flatMap((cat) => [
      cat.id,
      ...(Array.isArray(cat.sub_categories)
        ? cat.sub_categories.map((sub) => sub.id)
        : []),
    ]);
    return ids.join(",");
  };

  // ✅ Fetch skills when categories change
  useEffect(() => {
    if (formData?.categories?.length) {
      const categoryIds = getCategoryIds(formData.categories);
      axiosInstance
        .get(`category?type=6&category_id=${categoryIds}`)
        .then((res) => {
          if (res?.data) {
            setAllSkills(res.data?.response);
            setPopularSkills(res.data?.response);
          }
        })
        .catch((err) => {
          console.error("Error fetching skills:", err);
        });
    }
  }, [formData?.categories]);

  // ✅ Dropdown selection with duplicate prevention
  const handleLanguageChange = (selectedOption) => {
    if (isDuplicateSkill(selectedOption.value, selectedSkills)) {
      urtoast("Duplicate Skill Not allowed.", 2);
      return;
    }
    const newSkill = { id: selectedOption.value, title: selectedOption.label };
    const updatedSkills = [...selectedSkills, newSkill];
    setSelectedSkills(updatedSkills);
    setSelectSkills(null);
  };

  // ✅ Popular skill addition with duplicate prevention
  const handleAddPopularSkill = (skill) => {
    if (isDuplicateSkill(skill.id, selectedSkills)) {
      urtoast("Duplicate Skill Not allowed.", 2);
      return;
    }
    const updatedSkills = [...selectedSkills, skill];
    setSelectedSkills(updatedSkills);
  };

  // ✅ Manual skill addition with duplicate prevention
  const handleAddManualSkill = () => {
    const trimmedSkill = manualSkill.trim();
    if (!trimmedSkill) return;

    const duplicate =
      isDuplicateSkill(trimmedSkill, selectedSkills) ||
      (Array.isArray(allSkills) &&
        allSkills.some(
          (skill) => skill.title.toLowerCase() === trimmedSkill.toLowerCase()
        ));

    if (duplicate) {
      urtoast("Duplicate Skill Not allowed.", 2);
      return;
    }

    const newSkill = { id: trimmedSkill, title: trimmedSkill };
    const updatedSkills = [...selectedSkills, newSkill];
    setSelectedSkills(updatedSkills);
    setManualSkill("");
    setAddmanual(false);
  };

  const handleDeleteLanguage = (id) => {
    const updatedSkills = selectedSkills.filter((skill) => skill.id !== id);
    setSelectedSkills(updatedSkills);
  };

  const handleSave = () => {
    if (selectedSkills.length >= 3) {
      setFormData((prevData) => ({
        ...prevData,
        skills: selectedSkills,
      }));

      const data = { type: "skills", skills: selectedSkills };
      if (edittype === 1) {
        dispatch(updateProfile(data));
      }
      setModalSkills(false);
    } else {
      setValidation(true);
    }
  };

  return (
    <>
      <button
        onClick={() => setModalSkills((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt="close"
        />
      </button>

      <ModalBody>
        <h4>Edit Competencies</h4>
        <div className="form-group">
          <label className="label">Search or add competencies</label>

          <ReactSelect
            options={
              Array.isArray(allSkills)
                ? allSkills
                  .filter(
                    (skill) => !isDuplicateSkill(skill.id, selectedSkills)
                  )
                  .map((skill) => ({ value: skill.id, label: skill.title }))
                : []
            }
            placeholder="Select competencies"
            isClearable={true}
            value={selectSkills}
            onChange={(option) => option && handleLanguageChange(option)}
          />

          <p>Add up to 5 competencies for best results</p>
          {validation && (
            <p style={{ color: "red" }}>Please add at least 3 skills</p>
          )}

          <button
            className="add-plus btn"
            onClick={() => setAddmanual(true)}
          >
            + Add competencies Manually
          </button>
          {addmanual && (
            <div className="manualskill-input mb-3">
              <input
                type="text"
                value={manualSkill}
                onChange={(e) => setManualSkill(e.target.value)}
                placeholder="Type a competencies"
                className="form-control"
                style={{ width: "65%" }}
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    e.preventDefault();
                    handleAddManualSkill();
                  }
                }}
              />
              <button type="button" onClick={handleAddManualSkill}>
                Add
              </button>
              <button type="button" onClick={() => setAddmanual(false)}>
                Close
              </button>
            </div>
          )}

          <div className="add-skills">
            {selectedSkills.map((skill, index) => (
              <div key={index} onClick={() => handleDeleteLanguage(skill.id)}>
                <p>
                  {skill.title} <span>x</span>
                </p>
              </div>
            ))}
          </div>

          <div className="popular-skill">
            <h5 className="mt-2">Popular competencies based on your designation</h5>
            <div className="add-skills">
              {popularSkills
                .filter((skill) => !isDuplicateSkill(skill.id, selectedSkills))
                .map((skill, index) => (
                  <div key={index} onClick={() => handleAddPopularSkill(skill)}>
                    <p className="select-deactive-skill">
                      {skill.title} <span>+</span>
                    </p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </ModalBody>

      <div className="modal-footer mt-3">
        <button className="btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </>
  );
}
